<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if */
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PlatformAnnouncementsAPI from 'dashboard/api/platformAnnouncements';

const route = useRoute();
const router = useRouter();
const announcement = ref(null);
const accountId = computed(() => route.params.accountId);

const load = async () => {
  if (!accountId.value) return;
  try {
    const { data } = await PlatformAnnouncementsAPI.get();
    announcement.value =
      data.payload.find(item => !item.read_at && !item.dismissed_at) || null;
  } catch (error) {
    announcement.value = null;
  }
};

const openInbox = async () => {
  if (announcement.value)
    await PlatformAnnouncementsAPI.read(announcement.value.id);
  announcement.value = null;
  router.push({
    name: 'platform_announcements',
    params: { accountId: accountId.value },
  });
};

const dismiss = async () => {
  if (!announcement.value) return;
  await PlatformAnnouncementsAPI.dismiss(announcement.value.id);
  announcement.value = null;
};

watch(accountId, load, { immediate: true });
</script>

<template>
  <aside
    v-if="announcement"
    class="fixed right-5 top-5 z-50 w-[min(24rem,calc(100vw-2.5rem))] overflow-hidden rounded-xl border border-n-brand/40 bg-n-solid-2 shadow-2xl"
  >
    <img
      v-if="announcement.image_url"
      :src="announcement.image_url"
      :alt="announcement.title"
      class="max-h-40 w-full object-cover"
    />
    <div class="p-4">
      <div class="flex items-start justify-between gap-3">
        <div>
          <p class="text-xs font-semibold uppercase tracking-wide text-n-brand">
            Novidade
          </p>
          <h2 class="mt-1 font-semibold text-n-slate-12">
            {{ announcement.title }}
          </h2>
        </div>
        <button
          class="rounded-md p-1 text-n-slate-10 hover:bg-n-alpha-1"
          title="Dispensar"
          @click="dismiss"
        >
          <span class="i-lucide-x size-4" />
        </button>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div
        v-dompurify-html="announcement.body"
        class="mt-2 line-clamp-3 whitespace-pre-line text-sm leading-5 text-n-slate-11"
      />
      <button
        class="mt-4 text-sm font-semibold text-n-brand hover:underline"
        @click="openInbox"
      >
        Abrir caixa de novidades
      </button>
    </div>
  </aside>
</template>
